module.exports = __webpack_public_path__ + "static/media/Matafuegos.7f4f6f71.jpg";